<div class="sidenav-container h-100" [class.sidenav-container__basic]="openMenu" *ngIf="availableTemplates$ | async as templates">
  <div class="sidenav-container__brand" [class.collapsed]="collapsed" *ngIf="!openMenu">
    <div class="cursor-pointer flex align-center py-5" [ngClass]="{'justify-center': collapsed, 'justify-space-between': !collapsed}" [routerLink]="RoutesUtil.Dashboard.url()">
      <app-logo [type]="collapsed ? 'symbol' : 'full'" size="xs" [customLogo]="userLogo" [ngClass]="{'pl-5': !collapsed}"></app-logo>
      <div *ngIf="!collapsed" class="sidenav-container__collapse-btn" (click)="handlecollapse($event)">
        <app-icon class="text-primary d-inline align-center mr-4" size="xs" name="arrow-left-double-fill"></app-icon>
      </div>
    </div>
    <div *ngIf="collapsed" class="sidenav-container__collapse-btn collapsed mb-2" (click)="handlecollapse($event)">
      <app-icon class="text-primary d-inline" size="xs" name="arrow-left-double-fill"></app-icon>
    </div>
  </div>

  <mat-nav-list class="sidenav-container__popover-container" *ngIf="openMenu">
    <mat-list-item
      [popoverTrigger]="avatarPopover"
      [closeOnClickOutside]="true"
      [position]="position"
      [width]="'auto'"
      [backDrop]="false"
      (click)="showArrow = !showArrow"
    >
      <div class="flex justify-space-between align-center w-100">
        <div class="flex align-center" *ngIf="!showArrow">
          <img class="mr-2" src="../../../../assets/images/avatar.med.svg" />
          <div class="flex column m">
            <span class="sidenav-container__avatar-title">{{userFirstName}} {{userLastName}}</span>
            <span class="sidenav-container__avatar-subtitle">{{userEmail}}</span>
          </div>
        </div>
        <mat-icon class="d-inline icon icon--small align-center" *ngIf="!showArrow">arrow_forward</mat-icon>
        <mat-icon class="d-inline icon icon--small align-center" *ngIf="showArrow">arrow_back</mat-icon>
      </div>
    </mat-list-item>
  </mat-nav-list>

  <app-nav-list
    [menuList]="items"
    [color]="openMenu ? 'basic' : 'primary'"
    [collapsed]="collapsed"
    [divider]="openMenu"
    (click)="closeMenu()"
    #navList
  ></app-nav-list>

  <div class="sidenav-container__create" *ngIf="!openMenu && viewCardBtn">
    <div
      class="sidenav-container__btn-card"
      [matMenuTriggerFor]="showTemplatesMenu ? menu : null"
      [class.collapsed]="collapsed"
      *grantAccess="RolesConstants.SHIPMENT_ADD"
      (click)="!showTemplatesMenu ? onClickCreateShipment() : null"
    >
      <span class="sidenav-container__btn-icon d-inline-flex align-center justify-center">
        <app-icon name="outline-add" size="xs"></app-icon>
      </span>

      <span class="flex align-center" *ngIf="!collapsed">
        <span class="unified-line-height">
          {{'Enum.RequestHistoryAction.CREATE_SHIPMENT' | translate}}
        </span>
        <app-icon *ngIf="showTemplatesMenu" class="ml-1" size="xs" name="outline-arrow-down"></app-icon>
      </span>
    </div>

    <mat-menu #menu="matMenu" xPosition="before" yPosition="above" class="w-100">
      <ng-container *ngFor="let template of templates;">
        <button mat-menu-item (click)="navigateToTemplate(template.type)" class="w-100 my-2">
          <span class="d-flex align-center">
            <span class="d-inline-flex align-center justify-center p-2 mr-2 radius-2 bg-accent-lighter text-accent">
              <app-icon class="text-accent" name="outline-box" size="xs"></app-icon>
            </span>
            <span class="flex column">
              <span class="h6 m-0 weight-medium">{{ 'Enum.ShipmentCreationTemplateTypes.' + template.type | translate }}</span>
              <span class="small text-default text-nowrap">{{ 'Buttons.CreateSingleShipmentDescription' | translate }}</span>
            </span>
          </span>
        </button>
      </ng-container>
    </mat-menu>
  </div>
</div>

<ng-template #avatarPopover>
  <mat-nav-list class="popover-container">
    <app-avatar-Menu (click)="closeMenu();showArrow = !showArrow"></app-avatar-Menu>
  </mat-nav-list>
</ng-template>
